/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PermissionGrant from './PermissionGrant';

/**
 * The InheritedPermissionGrant model module.
 * @module model/InheritedPermissionGrant
 * @version 1.0.0
 */
class InheritedPermissionGrant {
    /**
     * Constructs a new <code>InheritedPermissionGrant</code>.
     * @alias module:model/InheritedPermissionGrant
     */
    constructor() { 
        
        InheritedPermissionGrant.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InheritedPermissionGrant</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InheritedPermissionGrant} obj Optional instance to populate.
     * @return {module:model/InheritedPermissionGrant} The populated <code>InheritedPermissionGrant</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InheritedPermissionGrant();

            if (data.hasOwnProperty('sourceAssetId')) {
                obj['sourceAssetId'] = ApiClient.convertToType(data['sourceAssetId'], 'String');
            }
            if (data.hasOwnProperty('sourceAssetTitle')) {
                obj['sourceAssetTitle'] = ApiClient.convertToType(data['sourceAssetTitle'], 'String');
            }
            if (data.hasOwnProperty('grant')) {
                obj['grant'] = PermissionGrant.constructFromObject(data['grant']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InheritedPermissionGrant</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InheritedPermissionGrant</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['sourceAssetId'] && !(typeof data['sourceAssetId'] === 'string' || data['sourceAssetId'] instanceof String)) {
            throw new Error("Expected the field `sourceAssetId` to be a primitive type in the JSON string but got " + data['sourceAssetId']);
        }
        // ensure the json data is a string
        if (data['sourceAssetTitle'] && !(typeof data['sourceAssetTitle'] === 'string' || data['sourceAssetTitle'] instanceof String)) {
            throw new Error("Expected the field `sourceAssetTitle` to be a primitive type in the JSON string but got " + data['sourceAssetTitle']);
        }
        // validate the optional field `grant`
        if (data['grant']) { // data not null
          PermissionGrant.validateJSON(data['grant']);
        }

        return true;
    }


}



/**
 * @member {String} sourceAssetId
 */
InheritedPermissionGrant.prototype['sourceAssetId'] = undefined;

/**
 * @member {String} sourceAssetTitle
 */
InheritedPermissionGrant.prototype['sourceAssetTitle'] = undefined;

/**
 * @member {module:model/PermissionGrant} grant
 */
InheritedPermissionGrant.prototype['grant'] = undefined;






export default InheritedPermissionGrant;

